module.exports = __webpack_public_path__ + "static/media/footerbg.59a0a377.png";